import { ComposeViewState } from 'owa-mail-compose-store';
import trySaveMessage from 'owa-mail-compose-store/lib/actions/trySaveMessage';

const saveItem = (viewState: ComposeViewState) => (): Promise<string> => {
    return trySaveMessage(viewState, /* autoSave */ false, /* rejectWhenFail */ true)
        .then(() => Promise.resolve(viewState.itemId.Id))
        .catch(() => Promise.resolve(null));
};

export default saveItem;
